import React, {Component} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import {contructQueryParam, fetchDataAsync} from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import {ACTIVITY_TYPE, HttpStatus, Status} from "../../../common/Constants";
import {flattenFormGroupObject, mapToObjectDDL} from "../../../common/mapper";
import SimpleDDL from "../../../../modules/SimpleDDL";
import ToggleButton from "react-toggle-button";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import {service} from "../service";
import * as R from "ramda";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";

class MasterServiceModifying extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceId: null,
            categoryOptions: [],
            variantOptions: [],
            errors: {},
            mandatoryErrorVisible: false,
            confirmVisible: false,
        };
    };

    componentDidMount = async () => {
        this.props.triggerLoading();
        if (R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
            await this.fetchDataDetail();
        }
        await this.fetchDataVariant();
        await this.fetchDataCategory();
        this.props.triggerLoading();
    };

    fetchDataDetail = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").masterServiceDetail,
            menuName: "Master Jasa/Job",
            setError: this.props.setError,
            args: contructQueryParam({serviceId: this.props.controls.serviceId.value}),
        });
        if (res.ok && R.equals(res.data.status, HttpStatus.SUCCESS)) {
            let {data} = res.data;
            this.props.setValue("kodeJasa", data.serviceCode);
            this.props.setValue("namaJasa", data.serviceName);
            this.props.setValue("frt", data.frt);
            this.props.setValue("serviceCategory", mapToObjectDDL(data.serviceCategory.value, data.serviceCategory.key));
            this.props.setValue("kodeVarian", mapToObjectDDL(data.variant.kodeVariant, data.variant.kodeVariant));
            this.props.setValue("namaVarian", mapToObjectDDL(data.variant.namaVariant, data.variant.kodeVariant));
            this.props.setValue("status", data.status);
        }
    };

    fetchDataVariant = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
            setError: this.props.setError,
            menuName: "Master Jasa/Job",
            args: null,
        });
        if (res.ok && R.equals(res.data.status, HttpStatus.SUCCESS)) {
            this.setState((prevValue) => ({
                ...prevValue,
                variantOptions: res.data.data,
            }));
        }
    };

    fetchDataCategory = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
            setError: this.props.setError,
            menuName: "Master Jasa/Job",
            args: {paramFilters: {bizparCategory: "SERVICE_CATEGORY"}},
        });
        if (res.ok && R.equals(res.data.status, HttpStatus.SUCCESS)) {
            this.setState((prevValue) => ({
                ...prevValue,
                categoryOptions: res.data.data.map(item => mapToObjectDDL(item.value, item.key)),
            }));
        }
    };

    handleChangeVariant = (name, value) => {
        let variant = this.state.variantOptions.find(item => item.kodeVariant === value.value);
        this.props.setValue("kodeVarian", mapToObjectDDL(variant.kodeVariant, variant.kodeVariant));
        this.props.setValue("namaVarian", mapToObjectDDL(variant.namaVariant, variant.kodeVariant));
    };

    handleClear = () => {
        this.props.setValue("kodeJasa", null);
        this.props.setValue("namaJasa", null);
        this.props.setValue("frt", null);
        this.props.setValue("serviceCategory", null);
        this.props.setValue("kodeVarian", null);
        this.props.setValue("namaVarian", null);
        this.props.setValue("status", Status.ACTIVE);
    };

    handleSubmit = () => {
        let {controls} = this.props;
        let err = service.validate(flattenFormGroupObject(controls));
        if (!R.isEmpty(err)) {
            this.handleMandatoryErrorVisibility();
            this.setState((prevValue) => ({...prevValue, errors: err}));
        } else {
            this.handleConfirmVisibility();
        }
    };

    handleConfirmVisibility = (type) => {
        this.setState((prevValue) => ({...prevValue, confirmVisible: !prevValue.confirmVisible}));
        if (R.equals(type, "confirm")) {
            this.props.onSubmit(this.props.controls);
        }
    };

    handleMandatoryErrorVisibility = () => {
        this.setState((prevValue) => ({...prevValue, mandatoryErrorVisible: !prevValue.mandatoryErrorVisible}));
    };

    render() {
        let {categoryOptions, variantOptions, errors} = this.state;
        let {controls} = this.props;
        return (
            <>
                <SimpleModal
                    title="Form Master Jasa"
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <>
                            <ModalContainer>
                                <SimpleInput
                                    id="input_text_kode_jasa"
                                    mandatory
                                    name="kodeJasa"
                                    label="Kode Jasa/Job"
                                    value={controls?.kodeJasa?.value}
                                    onChange={({target}) => this.props.setValue(target.name, target.value)}
                                    errorMessage={errors?.kodeJasa}
                                />
                                <SimpleInput
                                    id="input_text_nama_jasa"
                                    mandatory
                                    name="namaJasa"
                                    label="Nama Jasa"
                                    value={controls?.namaJasa?.value}
                                    onChange={({target}) => this.props.setValue(target.name, target.value)}
                                    errorMessage={errors?.namaJasa}
                                />
                                <SimpleInput
                                    box="onlyNumberNoDecimal"
                                    id="input_number_frt"
                                    mandatory
                                    name="frt"
                                    label="FRT"
                                    value={controls?.frt?.value}
                                    onChange={({target}) => this.props.setValue(target.name, target.value)}
                                    errorMessage={errors?.frt}
                                />
                                <SimpleDDL
                                    box="search"
                                    id="select_options_service_category"
                                    mandatory
                                    name="serviceCategory"
                                    label="Service Category"
                                    options={categoryOptions}
                                    value={controls?.serviceCategory?.value}
                                    onChange={(value, {name}) => this.props.setValue(name, value)}
                                    errorMessage={errors?.serviceCategory}
                                />
                                <SimpleDDL
                                    box="search"
                                    id="select_options_kode_varian"
                                    mandatory
                                    name="" kodeVarian
                                    label="Kode Varian"
                                    options={variantOptions.map(item => mapToObjectDDL(item.kodeVariant, item.kodeVariant))}
                                    value={controls?.kodeVarian?.value}
                                    onChange={(value, {name}) => this.handleChangeVariant(name, value)}
                                    errorMessage={errors?.kodeVarian}
                                />
                                <SimpleDDL
                                    box="search"
                                    id="select_options_nama_varian"
                                    mandatory
                                    name="namaVarian"
                                    label="Nama Varian"
                                    options={variantOptions.map(item => mapToObjectDDL(item.namaVariant, item.kodeVariant))}
                                    value={controls?.namaVarian?.value}
                                    onChange={(value, {name}) => this.handleChangeVariant(name, value)}
                                    errorMessage={errors?.namaVarian}
                                />
                                <ToggleButton
                                    name="status"
                                    label="Status"
                                    value={controls?.status?.value === Status.ACTIVE}
                                    onToggle={(value) => this.props.setValue("status", !value ? Status.ACTIVE : Status.INACTIVE)}
                                />
                                <FlexView style={{justifyContent: "right"}}>
                                    <SimpleButton onClick={this.handleClear}>Hapus</SimpleButton>
                                    <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                                </FlexView>
                            </ModalContainer>
                        </>
                    }
                />
                {this.state.confirmVisible && (
                    <SimpleAlert
                        title="Pertanyaan"
                        content="Apakah anda yakin ingin menyimpan data ini?"
                        visible={this.state.confirmVisible}
                        onClickClose={this.handleConfirmVisibility}
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{alignItems: "end"}}>
                                <SimpleButton
                                    type="button"
                                    text="Tidak"
                                    onClick={() => this.handleConfirmVisibility()}
                                />
                                <SimpleButton
                                    type="button"
                                    text="Ya"
                                    onClick={() => this.handleConfirmVisibility("confirm")}
                                />
                            </FlexView>
                        }
                    />
                )}
                {this.state.mandatoryErrorVisible && (
                    <SimpleAlert
                        title="Peringatan"
                        content="Terdapat data yang belum lengkap, mohon periksa kembali"
                        visible={this.state.mandatoryErrorVisible}
                        onClickClose={this.handleMandatoryErrorVisibility}
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{alignItems: "center"}}>
                                <SimpleButton
                                    type="button"
                                    text="OK"
                                    onClick={() => this.handleMandatoryErrorVisibility()}
                                />
                            </FlexView>
                        }
                    />
                )}
            </>
        );
    };
}

export default withFormGroup(MasterServiceModifying);